import { createFileRoute } from '@tanstack/react-router';
import { Users } from '../../../features/management/users/users';
import {
  createPermissionGuard,
  getPermissionSet,
  USER_MANAGEMENT_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/verwaltung/benutzer/')({
  component: Users,
  beforeLoad: createPermissionGuard(
    getPermissionSet(USER_MANAGEMENT_PERMISSIONS, 'EDIT'),
  ),
});

export const ListUsersRoute = Route;
